import { Root, rootLoader as loader, useLoaderData } from '@ubo/losse-sjedel';
import type { LinksFunction, RootProps } from '@ubo/losse-sjedel';
import ErrorBoundaryComponent from '~/components/layout/ErrorBoundary';
import styles from '~/global.css';
import FlexContent from './graphql/FlexContent';
import Queries from './graphql/Queries';
import PostTypes from './graphql/PostTypes';

export const flexData = {
  flexContent: FlexContent,
  queries: Queries,
  postTypes: PostTypes
};

export const links: LinksFunction = () => {
  return [
  {
    rel: 'preload',
    as: 'style',
    href: styles
  },
  {
    href: '/static/nprogress.min.css',
    rel: 'stylesheet',
    async: true
  },
  {
    rel: 'stylesheet',
    href: '/static/rc-slider.css',
    async: true
  },
  {
    rel: 'preload',
    as: 'style',
    href: styles
  },
  {
    href: styles,
    rel: 'stylesheet'
  },
  {
    href: '/manifest.json',
    rel: 'manifest'
  },
  {
    rel: 'icon',
    href: '/favicon.svg',
    type: 'image/svg+xml'
  },
  {
    rel: 'stylesheet',
    href: 'https://use.typekit.net/ehz1rlp.css'
  }];

};

export { loader };

export function ErrorBoundary() {
  return <ErrorBoundaryComponent />;
}

export default function App() {
  const data = useLoaderData<RootProps>();

  // @ts-expect-error
  return <Root {...data} useNormalScrollRestoration />;
}